module.exports = {
  language: 'العربية',
  applierApplicationCenter: {
    selectCenterTip: 'حدد هذا المركز'
  },
  multiplePage: {
    moreInfomation: 'معلومات اكثر',
    recommendedServices: 'الخدمات الموصى بها'
  },
  checkoutConfirm: {
    ordered: 'الخدمات المطلوبة مسبقًا',
    purchased: 'الخدمات المشتراة'
  },
  personal: {
    purgePopupContent: 'عذرًا ، لقد تم حذف التطبيق الخاص بك بسبب سياسة الأمان ، يمكنك الاتصال بنا إذا كنت تريد تقديم طلب جديد قريبًا.'
  },
  login_maximum: {
    errorContent: 'عذرا ، لقد وصلت إلى الحد الأقصى لعدد مرات تسجيل الدخول اليوم ، يرجى المحاولة في اليوم التالي.'
  },
  nationalityKay: 'ar-ar',
  noneSelectedText: 'الرجاء التحديد',
  multiselect: {
    deselect: 'اضغط على Enter للحذف',
    select: 'اضغط على Enter للتحديد',
    selected: 'تم التحديد'
  },
  enter: 'يدخل',
  upload_failed: 'فشل التحميل ، يرجى إعادة المحاولة',
  due_time: 'عند الوقت',
  requirement: 'المتطلبات',
  something_went_wrong_please_retry: '.هناك خطأ ما, حاول مرة اخرى',
  valid_rediret_home_page_popup_content:
    'حدث استثناء تسجيل الدخول. هل تحاول الانتقال إلى الصفحة الرئيسية لـ [ {country} - {center} ] لتسجيل الدخول؟ إذا كانت الإجابة بنعم ، يرجى النقر فوق "تأكيد" ؛ إذا كانت الإجابة "لا" ، يرجى النقر فوق "إلغاء" للتحديد مرة أخرى.',
  invalid_rediret_home_page_popup_content: 'حدث استثناء لتسجيل الدخول ، يرجى تحديد الدولة والموقع للمتابعة.',
  'Temporarily not available': 'غير متوفر مؤقتا',
  'Coming soon': 'قريبا'
};
